module.exports = __webpack_public_path__ + "media/images/we-have-the-meats-9ef10154.jpg";